


















import Vue from 'vue';
import { mapGetters } from 'vuex';

import Section from '@/components/Bulma/Section.vue';
import Columns from '@/components/Bulma/Columns.vue';
import Column from '@/components/Bulma/Column.vue';
import ProductCard from '@/components/ProductCard.vue';
import Product from '@/components/Product.vue';

import Util from '@/util/Util';

export default Vue.extend({
	name: 'Likes',

	components: {
		Section,
		ProductCard,
		Columns,
		Column,
		Product
	},

	created() {
		Util.updateHeaders(this.$text('likesTitle'), this.$text('likesSubTitle2'), process.env.VUE_APP_DEFAULT_IMAGE);
	},

	computed: {
		...mapGetters(['likedProducts', 'numberProductLikes'])
	}

});
